export const SocialData=[
    {
        platform:"Linkedin",
        icon: require("../../assets/icons/linkedin.png"),
        link:"https://www.linkedin.com/in/thuc-nguyen-duy-335b48a6",
    },
    {
        platform:"Github",
        icon: require("../../assets/icons/github.png"),
        link:"https://github.com/nguyenduythuc",
    },
    {
        platform:"Skype",
        icon: require("../../assets/icons/skype.png"),
        link:"https://join.skype.com/invite/cazwHOQKIKLT",
    },
];